import React from "react";
import { twMerge, twJoin } from "tailwind-merge";

import { useOptions } from "./hooks/useOptions";

export interface ColorButtonProps {
  className?: string;
  defaultOption?: string;
  options: string[];
  onChange?: (option: string) => void;
}

export function SupColorButton({ className, defaultOption, options, onChange }: ColorButtonProps) {
  const { currentIndex, setCurrentOptionByIndex } = useOptions(options, { defaultOption, onChange });

  const handleClick = (index: number) => () => {
    setCurrentOptionByIndex(index);
  };

  return (
    <div className={twMerge("inline-flex h-10 border-t-0.5 border-b-0.5 border-r-0.5 border-neutral-600", className)}>
      {options.map((option, i) => (
        <span
          key={option}
          tabIndex={0}
          className={twJoin("flex-1 w-5 border-l-0.5 border-neutral-600 bg-neutral-50 transition-colors cursor-pointer", currentIndex === i && "bg-neutral-700")}
          onClick={handleClick(i)}
        />
      ))}
    </div>
  );
}
